<template>
  <div>
    <template v-if="object.image">
      <a v-if="isTif(object.image)"
         :href="object.image"
         target="_blank">
        {{ $t('link') }}
      </a>
      <div v-else style="width: 100px;">
        <expandable-image :src="object.image"/>
      </div>
    </template>
    <template v-if="!object.image && object.url">
      <a :href="object.url" target="_blank">{{ $t('link') }}</a>
    </template>
    <template v-if="!object.image && !object.url"
              @click="addScan">
      <AddSvg/>
    </template>
  </div>
</template>

<script setup>
import AddSvg from '@/assets/svg-vue/general/add.svg'
import {useStore} from "vuex"

defineProps({
  object: {
    type: Object
  }
})

const store = useStore()

const addScan = () => {
  store.commit('setViewModel', 'scan')
  store.commit('setModule', 'patients')
  store.commit('setSelectedModel', {})
  store.commit('setShowModal', true)
}

const isTif = (url) => {
  return url.endsWith('.tif')
}
</script>
